import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import ProjectListTable from '../../../components/project-profit-sheet/ProjectListTable'

import { ppsSelector } from '../../../selectors'

const mapStateToProps = createStructuredSelector({
  data: ppsSelector.submits,
})

export default connect(mapStateToProps)(ProjectListTable)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/SubmitListTable.js